import { createSelector } from '@reduxjs/toolkit';

import type { PartnerLoyaltyState } from './slice';
import { name } from './slice';

export const partnerLoyaltyStateSelf = (state): PartnerLoyaltyState =>
  state[name];

export const getPartnerLoyaltyInfo = createSelector(
  partnerLoyaltyStateSelf,
  (state) => state.partnerLoyaltyInfo,
);

export const getPartnerLoyaltyProgramCardNumber = createSelector(
  partnerLoyaltyStateSelf,
  (state) => state.partnerLoyaltyProgramCardNumber,
);
